import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import { formatResponders } from '../formatters/Responders';
import { fetchAgentResponders } from './fetchAgentResponders';
export const fetchResponders = (agents = []) => {
  return fetchAgentResponders(agents).then(formatResponders).catch(error => {
    reportError({
      error
    });
  });
};